import type { RouteObject } from 'react-router-dom'
import { AppLayout } from '@/components/layout/AppLayout'
import { CustomersPage } from '@/pages/CustomersPage'
import { CustomerDetailPage } from '@/pages/CustomerDetailPage'
import { DeliveriesPage } from '../pages/DeliveriesPage'
import { ShipmentDetailPage } from '@/pages/ShipmentDetailPage'
import { InvoicesPage } from '../pages/InvoicesPage'
import { InvoiceDetailPage } from '@/pages/InvoiceDetailPage'
import { UsersPage } from '@/pages/UsersPage'
import { SystemPage } from '@/pages/SystemPage'
import { HistoryPage } from '@/pages/HistoryPage'
import { HistoryCustomerPage } from '@/pages/HistoryCustomerPage'
import { PermissionRoute } from './PermissionRoute'
import { HomeRoute } from './HomeRoute'

/**
 * Routes available only when a user is signed in.
 * Add new authenticated pages here. Wrap the element in PermissionRoute with
 * the permission(s) the matching backend route requires.
 */
export const AuthenticatedRoutes: RouteObject[] = [
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <HomeRoute />
      },
      {
        path: 'customers',
        element: (
          <PermissionRoute permissions={['customers.read']}>
            <CustomersPage />
          </PermissionRoute>
        )
      },
      {
        path: 'customers/:customerId',
        element: (
          <PermissionRoute permissions={['customers.read']}>
            <CustomerDetailPage />
          </PermissionRoute>
        )
      },
      {
        path: 'deliveries',
        element: (
          <PermissionRoute permissions={['shipments.read']}>
            <DeliveriesPage />
          </PermissionRoute>
        )
      },
      {
        path: 'shipments/:shipmentId',
        element: (
          <PermissionRoute permissions={['shipments.read']}>
            <ShipmentDetailPage />
          </PermissionRoute>
        )
      },
      {
        path: 'invoices',
        element: (
          <PermissionRoute permissions={['invoicing.read']}>
            <InvoicesPage />
          </PermissionRoute>
        )
      },
      {
        path: 'invoices/:invoiceId',
        element: (
          <PermissionRoute permissions={['invoicing.read']}>
            <InvoiceDetailPage />
          </PermissionRoute>
        )
      },
      {
        path: 'users',
        element: (
          <PermissionRoute permissions={['accounts.manage']}>
            <UsersPage />
          </PermissionRoute>
        )
      },
      {
        path: 'historik',
        element: (
          <PermissionRoute permissions={['history.write']}>
            <HistoryPage />
          </PermissionRoute>
        )
      },
      {
        path: 'historik/:customerId',
        element: (
          <PermissionRoute permissions={['history.write']}>
            <HistoryCustomerPage />
          </PermissionRoute>
        )
      },
      {
        path: 'system',
        element: (
          <PermissionRoute permissions={['invoicing.read', 'invoicing.run']}>
            <SystemPage />
          </PermissionRoute>
        )
      }
    ]
  }
]
